<template>
    <div class="industry-helper">
        <button type="button" class="btn btn-primary-empty text-uppercase industry-helper-btn" @click="showHelper">
            {{ button_text }}
        </button>

        <!-- Modal -->
        <div ref="helper" class="analysis-industry modal fade" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Analysis Industry Help</h4>
                    </div>
                    <div class="modal-body">
                        <div class="modal-subheader">
                            <i class="fa fa-info-circle m-r-5" style="font-size: 1.2em; vertical-align: middle;"></i>
                            <span class="text-bold">Choosing an industry that matches most of your samples will make ordering easier.</span>
                        </div>
                        <div class="modal-scroll-area">
                            <div class="industry-row" @click="selectIndustry(6)">
                                <h3 class="industry-title">Agriculture</h3>
                                Select agriculture if your samples will generally consist of the following:
                                <div class="agr">
                                    <span class="label">Soil Fertility</span>
                                    <span class="label">Fertilizer</span>
                                    <span class="label">Plant Tissue</span>
                                    <span class="label">Manure</span>
                                    <span class="label">Compost</span>
                                    <span class="label">Irrigation & Livestock Water</span>
                                    <span class="label">Soil Health</span>
                                </div>
                            </div>
                            <div class="industry-row gray-row" @click="selectIndustry(7)">
                                <h3 class="industry-title">Environmental</h3>
                                Select environmental if your samples will generally consist of the following:
                                <div class="env">
                                    <span class="label">Drinking Water</span>
                                    <span class="label">Wastewater</span>
                                    <span class="label">Soil</span>
                                    <span class="label">Sludges</span>
                                </div>
                            </div>
                            <div class="industry-row" @click="selectIndustry(8)">
                                <h3 class="industry-title">Animal Feed</h3>
                                Select animal feed if your samples will generally consist of the following:
                                <div class="ani">
                                    <span class="label">Finished Feeds</span>
                                    <span class="label">Shell Corn</span>
                                    <span class="label">Forages</span>
                                    <span class="label">Corn Oil</span>
                                    <span class="label">Rations</span>
                                </div>
                            </div>
                            <div class="industry-row gray-row" @click="selectIndustry(9)">
                                <h3 class="industry-title">Food & Ingredients</h3>
                                Select food if your samples will generally consist of the following:
                                <div class="foo">
                                    <span class="label">Allergens</span>
                                    <span class="label">Nutritional Labeling</span>
                                    <span class="label">GMO</span>
                                    <span class="label">Proximate Analysis</span>
                                    <span class="label">Sponges/Swabs for Pathogen Testing</span>
                                </div>
                            </div>
                            <div class="industry-row" @click="selectIndustry(10)">
                                <h3 class="industry-title">Pet Food</h3>
                                Select pet food if your samples will generally consist of the following:
                                <div class="pet">
                                    <span class="label">Wet Pet Food</span>
                                    <span class="label">Dry Pet Food</span>
                                    <span class="label">Pet Treats</span>
                                    <span class="label">Pet Food Ingredients</span>
                                </div>
                            </div>
                            <div class="industry-row gray-row" @click="selectIndustry(11)">
                                <h3 class="industry-title">Fuel</h3>
                                Select fuel if your samples will generally consist of the following:
                                <div class="fue">
                                    <span class="label">Ethanol</span>
                                    <span class="label">DDGs</span>
                                    <span class="label">Sulfur Tier III</span>
                                    <span class="label">Canadian</span>
                                    <span class="label">Denaturant</span>
                                    <span class="label">Other</span>
                                </div>
                            </div>
                            <div class="industry-row" @click="selectIndustry(12)">
                                <h3 class="industry-title">Nutrient Management</h3>
                                Select nutrient management if your samples will generally consist of the
                                following:
                                <div class="nut-man">
                                    <span class="label">Compost</span>
                                    <span class="label">Fertilizers</span>
                                    <span class="label">Lime</span>
                                    <span class="label">Manure</span>
                                    <span class="label">Growth Media</span>
                                    <span class="label">Irrigation Water</span>
                                    <span class="label">Livestock Suitability</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><i
                                class="fa fa-times"></i> Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .industry-helper {
        display: inline-block;
        width: 100%;
    }

    .industry-helper-btn {
        width: 100%;
    }

    .analysis-industry {

        .industry-title {
            margin-bottom: 5px;
            margin-top: 0px;
            font-weight: 700;
            text-align: left !important;
            color: #464646 !important;
            font-size: 20px;
        }
        .industry-row {
            padding: 20px 20px 20px 25px;
        }
        .industry-row:hover {
            background-color: darken(#f5f7fb, 5%);
            cursor: pointer;
        }
        .gray-row {
            background-color: #f5f7fb;
        }
        .gray-row:hover {
            background-color: darken(#f5f7fb, 5%);
            cursor: pointer;
        }
        .agr {
            font-size: 1.45em !important;
            .label {
                background-color: #7e6863;

            }
        }
        .env {
            font-size: 1.45em !important;
            .label {
                background-color: #727f80;
            }
        }
        .ani {
            font-size: 1.45em !important;
            .label {
                background-color: #efa73b;

            }
        }
        .foo {
            font-size: 1.45em !important;
            .label {
                background-color: #008d51;
            }
        }
        .pet {
            font-size: 1.45em !important;
            .label {
                background-color: #cd7b00;
            }
        }
        .fue {
            font-size: 1.45em !important;
            .label {
                background-color: #ce4100;
            }
        }
        .nut-man {
            font-size: 1.45em !important;
            .label {
                background-color: #1f69a1;
            }
        }

    }

</style>
<script>

    
  export default{
    props: {
        button_text: {}
    },

    data: function() {
            return {
                helper: null,
            }
        },
    methods: {
        showHelper : function()
        {
            this.helper.modal('show');
            setTimeout(this.setFocus,250);
        },
        selectIndustry: function(industry_id)
        {
            this.$emit('set-industry', industry_id);
            this.helper.modal('hide');
        },

    },
     mounted: function() {
            var vm = this;
            vm.helper = $(vm.$refs.helper);
            vm.helper.on('hidden.bs.modal', function() { vm.$emit('closed') });
            $('body').append(vm.help);
        }
 }







</script>



// WEBPACK FOOTER //
// industry-help-me-picker.vue?81e381a4